import { useEffect } from "react"

const BASE_TITLE = "Motimatic"

function getEnvPrefix(): string {
    if (import.meta.env.DEV) return "LOCAL · "
    if (import.meta.env.MODE === "development") return "DEV · "
    if (import.meta.env.MODE === "staging") return "STAGING · "
    return ""
}

export function useDocumentTitle(title: string | null | undefined) {
    useEffect(() => {
        const previous = document.title
        const prefix = getEnvPrefix()
        document.title = title ? `${prefix}${title} | ${BASE_TITLE}` : `${prefix}${BASE_TITLE}`
        return () => {
            document.title = previous
        }
    }, [title])
}
